import { useTheme } from 'styled-components'

import { Chip, CountryFlag, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AvailabilityCountryChip = ({ country }) => {
  const theme = useTheme()

  return (
    <Chip
      backgroundColor={theme.colors.primary.surface}
      color={theme.colors.primary.onSurface}
      label={
        <Styles.Label>
          <CountryFlag code={country.code} />
          <Text type="bodyMonospaced" tag="span" color={theme.colors.primary.onSurface}>
            {country.name}
          </Text>
        </Styles.Label>
      }
    />
  )
}

export default AvailabilityCountryChip
